import { roundMoney } from './money';

const LANG_TO_LOCALE: Record<string, string> = {
  es: 'es-AR',
  en: 'en-US',
  pt: 'pt-BR',
  fr: 'fr-FR',
  de: 'de-DE',
};

export function formatAmount(value: number, lang: string): string {
  const locale = LANG_TO_LOCALE[lang] || lang;
  const rounded = roundMoney(value);
  const fractionDigits = Number.isInteger(rounded) ? 0 : 2;
  return rounded.toLocaleString(locale, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });
}
